import { useState, useEffect } from 'react'
import actions from "../config.json";

export const useGoogleMapsKey = () => {
  const [apiKey, setApiKey] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchMapKey = async () => {
      try {
        const mapsUrl = actions["marriott-passions-v3/get-maps-key"];
        const response = await fetch(mapsUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        
        if (!data || !data.apiKey) {
          throw new Error('Invalid response from maps key service')
        }
        
        setApiKey(data.apiKey)
        setError(null)
      } catch (err) {
        console.error('Error fetching Google Maps API key:', err)
        setError('Failed to fetch Google Maps API key')
        setApiKey(null)
      } finally {
        setLoading(false)
      }
    }

    fetchMapKey()
  }, []) // Empty dependency array means this runs once on mount

  return {
    apiKey,
    loading,
    error,
    // Add a refresh method in case we need to retry fetching the key
    refresh: () => {
      setLoading(true)
      setError(null)
      setApiKey(null)
    }
  }
}

export default useGoogleMapsKey
